import { render, staticRenderFns } from "./CadastroComissao.vue?vue&type=template&id=3401e612&"
import script from "./CadastroComissao.vue?vue&type=script&lang=js&"
export * from "./CadastroComissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports